export default __webpack_public_path__ + "static/media/hk.1b9726cf.svg";